module.exports = __webpack_public_path__ + "static/media/Home-bg1.2aed1a62.jpg";